module.exports = "<div class=\"timeline-wrapper\">\n  <div class=\"timeline-item\">\n    <div class=\"animated-background\">\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/loaders/loader-image/loader-image.component.html
// module id = ../../../../../src/app/components/loaders/loader-image/loader-image.component.html
// module chunks = main